module.exports = {
  "dataLayerSitePrefix": "account"
};